(ns teamoesterreich.admin-mode.lebensretter.detail.lr-detail-form

  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.admin-mode.data.lebensretter :as d-lr]

            [teamoesterreich.admin-mode.data.lr-clearance :as d-lrClearance]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.lebensretter.detail.clearance-part :as clearance-part]

            [teamoesterreich.admin-mode.lebensretter.detail.device-part :as device-part]
            [teamoesterreich.admin-mode.lebensretter.detail.log-part :as log-part]
            [teamoesterreich.admin-mode.lebensretter.detail.training-documents-part :as training-documents-part]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]

            [teamoesterreich.admin-mode.modal.info-modal :as info-modal]

            [teamoesterreich.admin-mode.modal.send-message-modal :as send-message-modal]

            [teamoesterreich.admin-mode.static-data :as staticData]
            [teamoesterreich.admin-mode.ui-helper.preview-modal :as preview-modal]
            [teamoesterreich.element.backend-file :as backend-file]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.setup :refer [config]]

            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.email :refer [email]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.sync :refer [sync]]

            ))


(defonce DST_LIST staticData/DST_LIST)
(defn parse-date [date]
  ;(log/debug "################### " (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8) ))
  (js/Date.parse (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8))))


(defn date-conv [date]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count date) 12)
    (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)
         )
    ""
    ))

(defn time-conv [rest-time]
  (if (= "" (str rest-time))
    nil
    (str (subs rest-time 6 8) "." (subs rest-time 4 6) "." (subs rest-time 0 4))
    ))




(defn get-user-details [!actual-user tomId]
  (d-user/get-user-all tomId (fn [data] (reset! !actual-user data)))
  )

(defn get-it []
  (let [!st (r/atom {:message nil :retry-cnt 0 :edit false})
        !edit (r/cursor !st [:edit])
        !show-message-popup (r/cursor !st [:message])
        !retry-cnt (r/cursor !st [:retry-cnt])
        !lr-list-loaded (r/cursor vstate/app-state [:lr-list :loaded])
        !actual-user (r/cursor vstate/app-state [:selected-user])
        !tomId (r/cursor vstate/app-state [:path :entityId])
        !show-send-mail (r/cursor !st [:show-send-mail])
        !show-send-welcome-mail (r/cursor !st [:show-send-welcome-mail])
        !show-send-push (r/cursor !st [:show-send-push])
        !enlarge (r/cursor !st [:enlarge])
        ]
    (fn []
      (let [_ (when (and @!tomId (not (d-user/actual-user-valid? @!tomId !actual-user))) (get-user-details !actual-user @!tomId))]
        (if (or (not (:reqTomId @!actual-user)) (not= @!tomId (:reqTomId @!actual-user)) (:error @!actual-user))
          ;no data
          [mui/grid
           {:container false :item true
            :md        12                                   ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     {:marginTop "25px"}
            }

           [mui/card
            [mui/card-header
             {:title (str "Personalnummer: " @!tomId)}]
            [mui/card-content
             [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
             [:br]
             [:br]
             [:br]
             [mui/typography "Lade den Datensatz ... "]
             (if (> @!retry-cnt 0)                          ;;retry after some time
               [mui/typography {:color "primary"} (:error @!actual-user) " (" @!retry-cnt ")"]
               (do
                 [mui/typography {:color "primary"} "Versuch (" @!retry-cnt ")"]
                 (js/setTimeout (fn []
                                  (reset! !retry-cnt (inc @!retry-cnt))
                                  (d-user/actual-user-invalidate !actual-user) 2000)
                                )))
             [:br]
             [mui/button
              {:color   "primary"
               :variant "contained"
               :onClick (fn []
                          (reset! !lr-list-loaded false)
                          (a/set-page :lebensretter))
               }
              "Schließen"]
             [mui/button {
                          :style   {:margin-left "40px"}
                          :endIcon (r/as-element [sync])
                          :onClick #(d-user/actual-user-invalidate !actual-user)
                          } "Neu laden"]
             ]]]
          ;has data
          [mui/grid
           {:container false :item true
            :xl        10
            :md        12                                   ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     {:marginTop "25px"}
            }
           [mui/card {:style {:textAlign "left"}}

            [preview-modal/modal-by-path !enlarge]

            [mui/card-header
             {:title   (str @!tomId ") " (:user-title @!actual-user) " " (:user-firstName @!actual-user) " " (:user-lastName @!actual-user))
              :onClick #(get-user-details !actual-user @!tomId)}]

            [mui/card-content
             {:style {:maxWidth "1300px"}}
             [mui/grid
              {:container  true
               :direction  "row"
               :justify    "space-around"
               :alignItems "flex-start"
               :spacing    3
               }
              [mui/grid
               {:container false :item true
                :lg        9                                ;medium: 960px
                :md        8                                ;medium: 960px
                :xs        6                                ;extra-small: 0px
                }

               [mui/grid
                {:container  true
                 :direction  "row"
                 :justify    "space-around"
                 :alignItems "flex-start"
                 :spacing    3
                 }
                [mui/grid {:container false :item true :xs 4} [mui/text-field {:label "Geburtstag" :value (time-conv (:user-birthday @!actual-user)) :readOnly true :fullWidth true}]]
                ;[mui/grid {:container false :item true :xs 6} [mui/text-field {:label "Dienststelle" :value (get DST_LIST (:user-orgId @!actual-user)) :readOnly true :fullWidth true}]]
                [mui/grid {:container false :item true :xs 4} [mui/text-field {:label "Mobilnummer" :value (:user-phoneNumber @!actual-user) :readOnly true :fullWidth true}]]
                [mui/grid {:container false :item true :xs 4} [mui/text-field {:label "Email" :value (:user-email @!actual-user) :readOnly true :fullWidth true}]]
                [mui/grid {:container false :item true :xs 12} [mui/text-field {:label "Adresse" :value (str (:user-zip @!actual-user) " " (:user-city @!actual-user) ", " (:user-street @!actual-user) " " (:user-streetNo @!actual-user)) :readOnly true :fullWidth true}]]
                (when (= "toe" (:client config)) [mui/grid {:container false :item true :xs 6} [mui/text-field {:label "Datenherkunft" :value (str (:user-lrSource @!actual-user)) :readOnly true :fullWidth true}]])
                [mui/grid {:container false :item true :xs 6}
                 ;[mui/text-field {:label "RK-Mitarbeiter" :value "" :readOnly true :fullWidth true}]
                 ]
                ]]
              [mui/grid
               {:container false :item true
                :lg        3                                ;medium: 960px
                :md        4                                ;medium: 960px
                :xs        6                                ;extra-small: 0px
                :style     {:textAlign "right"}
                }
               (if (and (:user-portraitFileHash @!actual-user) (not= "" (:user-portraitFileHash @!actual-user)))
                 [backend-file/img {:hash     (:user-portraitFileHash @!actual-user)
                                    :preview? false
                                    :height   "130"
                                    :style    {:object-fit "contain"}
                                    :title    (str (:user-firstName @!actual-user) " " (:user-lastName @!actual-user))
                                    :alt      (str (:user-firstName @!actual-user) " " (:user-lastName @!actual-user))}]
                 [:img {:src    "/custom/img/placeholder-md.png"
                        :height "130"
                        :style  {:object-fit "contain"}
                        :title  (str (:user-firstName @!actual-user) " " (:user-lastName @!actual-user))
                        :alt    (str (:user-firstName @!actual-user) " " (:user-lastName @!actual-user))
                        }]
                 )
               [:br]
               [:br]
               [:br]

               [mui/button
                {:variant "contained"
                 :style   {:float "right"}
                 :onClick #(a/open-user-view (:user-tomId @!actual-user))
                 }
                "Mitglied Details öffnen"]
               ]

              ]]

            [mui/card-actions
             [info-modal/info-modal !show-message-popup @!show-message-popup "Ok" (fn [])]

             [(send-message-modal/email-template-modal !show-send-mail "lebensretter" (str "Email erstellen und an " @!show-send-mail ") " (:user-firstName @!actual-user) " " (:user-lastName @!actual-user) " senden:") "senden"
                                                       (fn [subject email from] (d-user/email-to-tomIds [@!show-send-mail] subject email from #(reset! !show-message-popup "Die Nachricht wurde gesendet!")))
                                                       nil
                                                       (fn [subject email from] (d-user/email-to-tomIds [@!show-send-mail] subject email from #(reset! !show-message-popup "Die Nachricht wurde gesendet!") :self))
                                                       )]

             [(send-message-modal/sms-modal !show-send-push "Sende Push Nachricht an Lebensretter App" "Senden"
                                            (fn [message] (d-lr/>send-push-message @!tomId message
                                                                                   #(reset! !show-message-popup "Push Nachricht gesendet!")
                                                                                   #(reset! !show-message-popup "Es ist ein Fehler beim Sender der Nachricht aufgetreten!"))))]


             [are-you-sure-modal/are-you-sure-modal !show-send-welcome-mail
              "Willkommens Email jetzt senden?" "Senden"
              (fn [] (d-lr/>send-welcome-mail @!tomId #(reset! !show-message-popup "Willkommens Email gesendet!")
                                              #(reset! !show-message-popup "Es ist ein Fehler beim Sender der Nachricht aufgetreten!")))
              #(reset! !show-send-welcome-mail false)
              ]


             [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                          :onClick   (fn [] (a/set-page :lebensretter))
                          }
              "Schließen"
              ]

             [mui/button {:size    "" :color "secondary"
                          :style   {:float "right"}
                          :onClick #(reset! !show-send-mail (:user-tomId @!actual-user))
                          :endIcon (r/as-element [email])
                          } "Email Nachricht senden"]

             [mui/button {:size    "" :color "secondary"
                          :style   {:float "right"}
                          :onClick #(reset! !show-send-welcome-mail (:user-tomId @!actual-user))
                          :endIcon (r/as-element [email])
                          } "Willkommensmail erneut senden"]
             ;
             ;[mui/button {:size    "" :color "secondary"
             ;             :style   {:float "right"}
             ;             :onClick #(reset! !show-send-push true)
             ;             :endIcon (r/as-element [send])
             ;             } "Pushnachricht an Lebensretter App senden"]
             ]
            ]


           (let [lrClearance (:user-lrClearance @!actual-user)]

             (log/debug "Clearances " (clj->js lrClearance))

             (if (not lrClearance)
               (do
                 [mui/card {:style {:textAlign "left"
                                    :marginTop "10px"
                                    }}
                  [mui/card-actions

                   [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                                :variant   "outlined"
                                :onClick   (fn [] (a/set-page :lebensretter))
                                }
                    "Schließen"
                    ]
                   [mui/button {:startIcon (r/as-element [add])
                                :style     {:textAlign  "left"
                                            :marginLeft "50px"}
                                :variant   "outlined"
                                :color     "primary"
                                :onClick   (fn [] (d-lrClearance/>user-add-edit-clearance (:user-uuid @!actual-user) {}
                                                                                          #(get-user-details !actual-user (:user-tomId @!actual-user))))
                                }
                    "Freigabeprozess starten"
                    ]]
                  ])


               [mui/card {:style {:textAlign "left"
                                  :marginTop "10px"
                                  }}
                [mui/card-header
                 {:sx    {:color (if (d-lrClearance/is-cleared lrClearance) "darkgreen" "darkred")}
                  :style {:color (if (d-lrClearance/is-cleared lrClearance) "darkgreen" "darkred")}
                  :title (cond
                           (d-lrClearance/is-cleared lrClearance)
                           (str "Freischaltung - aktiv")

                           (and (:lrClearance-valid lrClearance) (:lrClearance-extendDocument lrClearance))
                           (str "Freischaltung - Reaktivieren möglich")

                           :else "Freischaltung erstellen"
                           )
                  }]
                [mui/card-content
                 (when-not (:user-profileValid @!actual-user)
                   [mui/chip {:color "primary"
                              :label "Profil nicht vollständig"}])
                 (when-not (:user-identityValid @!actual-user)
                   [mui/chip {:color "primary"
                              :label "Identität nicht bestätigt"}])

                 ;[:div "Debug "  (:lrClearance-uuid lrClearance) [:pre (h/pretty-map lrClearance)]]

                 [(clearance-part/clearance !edit !actual-user lrClearance)]

                 ]
                ]
               ))

           [mui/card {:style {:textAlign "left" :marginTop "5px"}}
            [mui/card-header
             {:title "Hochgeladene Dokumente"}]
            [training-documents-part/unused-training-documents !enlarge !actual-user]
            [(training-documents-part/upload-block !actual-user)]]

           (let [lrDevices (:user-lrReceiver @!actual-user)]
             (log/debug "lrDevices" (clj->js lrDevices))
             [mui/card {:style {:textAlign        "left" :marginTop "10px"
                                :background-color (if (empty? lrDevices) "#f2cdcd" "#e4f7e4")}}

              [mui/card-header
               {:title (r/as-element
                         [:span (txt/transl "Lebensretter APP auf folgenden Geräten installiert")
                          [mui/icon-button {:label   "jetzt synchronisieren"
                                            :onClick #(d-lr/<sync-receiver (:user-tomId @!actual-user) (fn []))}
                           [sync {:fontSize "small"}]]])}

               ]

              [mui/card-content

               (if (empty? lrDevices)
                 [:h5 (txt/transl "keine Lebensretter APP installiert")]
                 [mui/grid
                  {:container  true
                   :direction  "row"
                   :justify    "space-around"
                   :alignItems "flex-start"
                   :spacing    3
                   }
                  (for [lrDevice lrDevices]
                    ^{:key (str "lrDevice-" (:lrReceiver-uuid lrDevice))}
                    [device-part/device-block (:lrReceiver-app lrDevice) (:lrReceiver-model lrDevice) (:lrReceiver-lastContact lrDevice) (:lrReceiver-version lrDevice)]
                    )]
                 )
               ]
              ])


           [log-part/log-block @!actual-user]

           [mui/card-actions

            [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                         :onClick   (fn [] (a/set-page :lebensretter))
                         }
             "Schließen"
             ]
            ]

           ]

          )))))
